import { render, staticRenderFns } from "./CadastrarSegmento.vue?vue&type=template&id=c838aec0&lang=pug"
import script from "./CadastrarSegmento.vue?vue&type=script&lang=js"
export * from "./CadastrarSegmento.vue?vue&type=script&lang=js"
import style0 from "./CadastrarSegmento.vue?vue&type=style&index=0&id=c838aec0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports